import React from "react";
import { Modal, Empty } from "antd";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";
import "react18-json-view/src/dark.css";

const jsonStyle = {
    backgroundColor: "#2a2a2b",
    padding: "10px",
    borderRadius: "5px",
};

function ResponseViewModal({ isModalVisible, handleCancel, initialValues }) {
    return (
        <Modal
            title={`RevenueCat Full Response${initialValues?.event_type ? ` - ${initialValues.event_type}` : ""}`}
            open={isModalVisible}
            footer={null}
            onCancel={handleCancel}
            width={800}
        >
            {initialValues?.full_response ? (
                <JsonView
                    src={initialValues.full_response}
                    dark={true}
                    theme="vscode"
                    style={jsonStyle}
                />
            ) : (
                <Empty description="No response payload" />
            )}
        </Modal>
    );
}

export default ResponseViewModal;
